import { DateTime } from 'luxon';
import { accountType, productPlan } from 'shared/constants.json';

export function isAccountExpired(accountSettings, now = DateTime.local()) {
  const expiresAt = accountSettings?.expiresAt;
  if (expiresAt === null || expiresAt === undefined) {
    return false;
  }
  const nowDateTime = typeof now === 'string' ? DateTime.fromISO(now) : now;
  // Mirrors the backend accountIsExpired check, which compares against the start
  // of today rather than the exact current time — otherwise an account expiring
  // later today reads as already expired as soon as its expiry hour passes.
  const startOfToday = nowDateTime.startOf('day');
  return DateTime.fromISO(expiresAt) <= startOfToday;
}

// An account can be self-service deleted in two states, and demo/partner/other
// accounts are always excluded: a trial that never signed a contract (active or
// expired), or a regular customer whose contract was signed, has since been
// canceled, and has now expired. Mirrors the backend accountDeletable validator.
export function isAccountDeletable(accountSettings, customerContract, now = DateTime.local()) {
  if (customerContract === null || customerContract === undefined) {
    throw new Error('isAccountDeletable: account has no customer contract');
  }

  const nowDateTime = typeof now === 'string' ? DateTime.fromISO(now) : now;
  const type = customerContract.accountType;
  const isRegular = type === accountType.regular;
  const isTrial = accountSettings?.planId === productPlan.trial;
  // signedAt/canceledAt are secret-masked (pkg/xfmr/service/secret): a set value
  // arrives as the string "hidden", an unset one is omitted entirely. We only rely
  // on their PRESENCE, which survives masking — never their date. The one real value
  // we read, expiresAt, lives on AccountSettings and is not masked.
  const hasSignedContract = customerContract.signedAt !== null && customerContract.signedAt !== undefined;
  const canceledAt = customerContract.canceledAt;
  const isChurned = canceledAt !== null && canceledAt !== undefined;

  const isUncontractedTrial = isTrial && !hasSignedContract && isRegular;
  const hasChurnedExpiredContract = isRegular && hasSignedContract && isChurned && isAccountExpired(accountSettings, nowDateTime);

  return isUncontractedTrial || hasChurnedExpiredContract;
}
